import { render, staticRenderFns } from "./chairShortlistedScreen.vue?vue&type=template&id=7ab2a571"
import script from "./chairShortlistedScreen.vue?vue&type=script&lang=js"
export * from "./chairShortlistedScreen.vue?vue&type=script&lang=js"
import style0 from "./chairShortlistedScreen.vue?vue&type=style&index=0&id=7ab2a571&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports